import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js";

const organizationEditFormStyle = {
	...customCheckboxRadioSwitch,
	actionContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	form: {
		padding: '0px 30px 0px 0px',
	},
	saveButton: {
		marginTop: '0px',
		marginRight: '5px',
		marginBottom: '0px',
		marginLeft: '5px',
		width: '143px',
		height: '43px',
		fontSize: '12px',
	},
	subTitle: {
		margin: '30px 0 0',
		fontWeight: 'bolder',
	},
	feature: {
		display: 'inline-block',
		margin: '0px 25px',
		minWidth: '50%',
	},
	label: {
		fontSize: '12px',
	},
	left: {
		textAlign: 'left',
	}
};

export default organizationEditFormStyle;
